import { Box, HStack, Square, Text, useColorModeValue } from '@ecoinvent/ui';

import { COLORS } from './constants';

const SupplyChainLegend = () => {
  const legendTextColor = useColorModeValue('gray.600', 'gray.400');
  const legendBg = useColorModeValue('white', COLORS.darkSurface);
  const legendBorderColor = useColorModeValue(COLORS.borderLight, COLORS.buttonOutlinedBorderDark);
  const legendShadow = useColorModeValue('sm', 'dark-lg');
  const inputColor = useColorModeValue(COLORS.greenLight, COLORS.greenDark);
  const datasetColor = useColorModeValue(COLORS.datasetBlueLight, COLORS.rootOutline);
  const consumerColor = useColorModeValue(COLORS.purpleLight, COLORS.purpleDark);

  const items = [
    { color: inputColor, label: 'Inputs' },
    { color: datasetColor, label: 'Selected dataset' },
    { color: consumerColor, label: 'Consuming activities' },
  ];

  return (
    // Paints above the graph: the `.react-flow` wrapper is its own `z-index: 0` stacking context.
    <Box
      position="absolute"
      bottom={4}
      left={4}
      zIndex={10}
      pointerEvents="none"
      bg={legendBg}
      borderRadius="md"
      // Outline, not border: Figma's 1px stroke does not add to the frame's 32px, and outlines sit outside the layout box.
      outline={`1px solid ${legendBorderColor}`}
      outlineOffset={0}
      boxShadow={legendShadow}
      py={2}
      px={3}
    >
      <HStack spacing={3}>
        {items.map(({ color, label }) => (
          <HStack key={label} spacing={1}>
            <Square size="12px" bg={color} borderRadius="sm" />
            {/* lineHeights.4 = 1rem = 16px, so the row is 16px and py={2} composes to the spec's 32px. */}
            <Text fontSize="xs" lineHeight="4" color={legendTextColor}>
              {label}
            </Text>
          </HStack>
        ))}
      </HStack>
    </Box>
  );
};

export default SupplyChainLegend;
